import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { buyingActionBand, RAG_PILL, type BuyingAction } from '../lib/reporting-format';
import { buyingActionLabel } from './on-order/types';

/**
 * Buying-action pill — colour (RAG band) + label, never colour alone (DESIGN
 * §16). Shared across every reporting surface that surfaces the On-Order
 * buying-action cross-reference (On-Order report, Blank consumption report) so
 * the palette + wording stay in lock-step. `order_now` reads urgent (red band).
 */
export const BuyingActionBadge: React.FC<{
  action: BuyingAction;
  className?: string;
}> = ({ action, className }) => {
  const { t } = useTranslation('inventory');
  return (
    <span
      className={cn(
        'inline-flex whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-semibold',
        RAG_PILL[buyingActionBand(action)],
        className,
      )}
    >
      {buyingActionLabel(action, t)}
    </span>
  );
};
